export default class UserInformation {
  username: string;
  email: string;
  createdAt: string;
  termCount: number;
  rank: number | null;

  constructor(
    username: string,
    email: string,
    createdAt: string,
    termCount: number,
    rank: number | null
  ) {
    this.username = username;
    this.email = email;
    this.createdAt = createdAt;
    this.termCount = termCount;
    this.rank = rank;
  }

  static fromJson(json: any): UserInformation {
    let username: string = json.username ?? "";
    let email: string = json.email ?? "";
    let createdAt: string = json.createdAt ?? "";
    let termCount: number = json.termCount ?? 0;
    return new UserInformation(
      username,
      email,
      createdAt,
      termCount,
      parseRank(json.rank)
    );
  }
}

// 랭킹이 없으면 null. 숫자/문자열 어느 쪽으로 와도 처리한다.
function parseRank(value: unknown): number | null {
  if (value === null || value === undefined || value === "") return null;
  const rank = Number(value);
  return Number.isInteger(rank) && rank > 0 ? rank : null;
}
